export default __webpack_public_path__ + "static/media/PD8050.30c0a803.png";